export enum EditorName {
  Body = "body",
  Notes = "notes",
  References = "references",
}

export enum ClassicEditorName {
  Body = "body",
  Notes = "notes",
  References = "references",
}

export enum ExtendedQuestionEditorName {
  Body = "body",
  References = "references",
}

export function classicEditorNameToEditorName(
  editorName: ClassicEditorName
): EditorName {
  switch (editorName) {
    case ClassicEditorName.Body:
      return EditorName.Body;
    case ClassicEditorName.Notes:
      return EditorName.Notes;
    case ClassicEditorName.References:
      return EditorName.References;
    default:
      throw new Error(
        `Unknown ClassicEditorName: ${editorName satisfies never}`
      );
  }
}

export function extendedQuestionEditorNameToEditorName(
  editorName: ExtendedQuestionEditorName
): EditorName {
  switch (editorName) {
    case ExtendedQuestionEditorName.Body:
      return EditorName.Body;
    case ExtendedQuestionEditorName.References:
      return EditorName.References;
    default:
      throw new Error(
        `Unknown ExtendedQuestionEditorName: ${editorName satisfies never}`
      );
  }
}